import {useSelector} from 'react-redux'
import styled from '@emotion/styled'
import {getAccommodationPageHotelId} from 'modules/accommodation/selectors'
import {OfferAccessFlow} from 'modules/sapiSearch/constants'
import {getSearchParameters} from 'modules/sapiSearch/selectors'
import {getRoomOfferAccessConfig} from 'modules/searchApi/selectors'

import {cssTheme} from '@vio/atlas/themes'
import {Offer} from '@vio/core/src/offer/types/offer'
import {Room} from '@vio/core/src/room/types/room'
import {SplitBooking} from '@vio/core/src/room/types/room'
import {useShouldShowDealFreezeButton} from '@vio/shared/src/dealFreeze/hooks/useShouldShowDealFreezeButton'

import {FrozenRoomOfferCTA} from '../Rooms/FrozenRoomOffer/FrozenRoomOfferCTA'
import {RoomOfferDealFreezeCTA} from '../Rooms/RoomOfferCTA/RoomOfferDealFreezeCTA'
import {RoomOfferRegularCTA} from '../Rooms/RoomOfferCTA/RoomOfferRegularCTA'

const SOURCE_COMPONENT = 'DealDetailsOverlay'

const RowCTALayout = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  flex-direction: row-reverse;
  gap: ${cssTheme.layout.spacing.s400};
`

type Props = {
  room?: Room
  offer?: Offer
  splitBooking?: SplitBooking
  isFrozen?: boolean
  bookingId?: string
}
export const DealDetailsBottomCTA = ({
  room,
  offer,
  splitBooking,
  isFrozen = false,
  bookingId
}: Props) => {
  const hotelId = useSelector(getAccommodationPageHotelId)
  const {checkIn, checkOut} = useSelector(getSearchParameters)
  const flowType = useSelector(state =>
    getRoomOfferAccessConfig(state, offer?.id)
  )
  const isOfferAppLocked = flowType === OfferAccessFlow.AppLocked

  const shouldShowDealFreezeButton = useShouldShowDealFreezeButton({
    offer,
    checkIn,
    checkOut,
    isOfferAppLocked,
    hotelId,
    isOfferSoldOut: false
  })
  if (!offer && !splitBooking) return null
  if (isFrozen) {
    return <FrozenRoomOfferCTA bookingId={bookingId} isCompactLayout />
  }
  return (
    <RowCTALayout>
      <RoomOfferRegularCTA
        hotelId={hotelId}
        room={room}
        offer={offer}
        splitBooking={splitBooking}
        component={SOURCE_COMPONENT}
      />

      {shouldShowDealFreezeButton && (
        <RoomOfferDealFreezeCTA hotelId={hotelId} room={room} offer={offer} />
      )}
    </RowCTALayout>
  )
}
